// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"d20b4ab6","453":"199821cb","977":"d488c74d"}[chunkId] + ".chunk.js";
};